import { render, staticRenderFns } from "./studyMore.vue?vue&type=template&id=5861af55&scoped=true"
import script from "./studyMore.vue?vue&type=script&lang=js"
export * from "./studyMore.vue?vue&type=script&lang=js"
import style0 from "./studyMore.vue?vue&type=style&index=0&id=5861af55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861af55",
  null
  
)

export default component.exports